import { render, staticRenderFns } from "./core.vue?vue&type=template&id=a0679b82&scoped=true"
import script from "./core.vue?vue&type=script&lang=js"
export * from "./core.vue?vue&type=script&lang=js"
import style0 from "./core.vue?vue&type=style&index=0&id=a0679b82&prod&lang=scss&scoped=true"
import style1 from "./core.vue?vue&type=style&index=1&id=a0679b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0679b82",
  null
  
)

export default component.exports